// Cross-references the currently selected Size against each colour sibling's
// own per-size stock, so a sibling's swatch shows a strikethrough whenever
// that sibling is out of stock in the size the shopper currently has selected.
(function () {
  function updateSwatchesForSize(size) {
    if (!size) return;

    document.querySelectorAll('.pdp-sibling-swatch[data-sizes]').forEach(function (swatch) {
      var sizesAttr = swatch.getAttribute('data-sizes');
      var oosForSize = false;

      if (sizesAttr) {
        try {
          var sizes = JSON.parse(sizesAttr);
          if (Object.prototype.hasOwnProperty.call(sizes, size) && sizes[size] === false) {
            oosForSize = true;
          }
        } catch (err) {
          // malformed data-sizes on this swatch; leave it untouched
        }
      }

      swatch.classList.toggle('is-oos-for-size', oosForSize);
    });
  }

  function getSelectedSize() {
    var checked = document.querySelector('input[data-option-name="Size"]:checked');
    return checked ? checked.value : null;
  }

  function init() {
    if (!document.querySelector('.pdp-sibling-swatches')) return;

    // React to the shopper changing their selected size.
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (target && target.getAttribute && target.getAttribute('data-option-name') === 'Size') {
        updateSwatchesForSize(target.value);
      }
    });

    // Reflect whatever size is selected by default on page load.
    updateSwatchesForSize(getSelectedSize());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
